<template>
  <div class="text-primary" id="blog">
    <div class="container py-5">
      <h2 class="display-4">Blog</h2>
      
      
      <div id="blogCarousel" class="my-3 carousel slide" data-ride="carousel" data-interval="3000">
        <ol class="carousel-indicators" style="bottom: -60px;">
          <li data-target="#blogCarousel" :data-slide-to="i" v-for="(blogGroup, i) in blogGroups" :key="i"></li>
        </ol>
        <div class="carousel-inner" style="padding-bottom: 30px;">
          <div class="carousel-item" v-for="(blogGroup, i) in blogGroups" :class="blogGroup.active">
            <div class="row">
              <div class="col-md-4 py-2 py-md-0" v-for="blog in blogGroup" :key="blog.id">
                <div class="card blog">
                  <div class="card-body">
                    <div class="img" v-bind:style="{ backgroundImage: 'url(' + blog._embedded['wp:featuredmedia']['0'].source_url + ')' }"></div>
                    <div class="text-container">
                      <h5 class="card-title title" v-html="blog.title.rendered" />
                      <a class="btn btn-outline-primary" :href="blog.link" target="_blank" v-if="blog.link">Read more</a>
                      </div>
                    </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      
    </div>
  </div>
</template>

<style lang="scss">
    #blog {
        padding-top: 40px;
        padding-bottom: 60px;
        
        .container {
            max-width: 1200px;
        }
    }
    
    #blogCarousel {
        .carousel-item {
            background-color: transparent;
        }
        .carousel-indicators {
            li {
                background-color: black;
            }
        }
    }
    
    .blog {
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        //margin: 20px;
        border: solid 1px #231f20 !important;
        border-radius: 0 !important;
        
        &:before {
            content: '';
            position: absolute;
            right: 0;
            bottom: 0;
            display: block;
            width: 0;
            height: 0;
            border-left: 60px solid transparent;
            border-right: 0px solid transparent;
            border-bottom: 60px solid #231f20;
        }
        
        &:after {
            content: '';
            position: absolute;
            right: -1px;
            bottom: -1px;
            display: block;
            width: 0;
            height: 0;
            border-left: 60px solid transparent;
            border-right: 0px solid transparent;
            border-bottom: 60px solid white;
        }
        
        .card-body {
            display: flex;
            flex-direction: column;
            width: 100%;
            padding: 0;
            border-radius: 0;
        }
        
        .img {
            height: 180px;
            width: 100%;
            background-size: cover;
            background-position: center;
            flex-shrink: 0;
            flex-grow: 0;
        }
        
        .text-container {
            width: 100%;
            padding: 30px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            flex-grow: 1;
        }
        
        .title {
            width: 100%;
            font-size: 26px;
            line-height: 34px;
            margin-bottom: 30px;
        }
        
        .btn {
            margin-top: auto;
            border-radius: 0;
            padding: 10px 25px;
        }
    }
</style>
<script>
import axios from "axios";
import { chunk } from "lodash";
import $ from "jquery";

export default {
  data() {
    return {
      posts: [],
      blogGroups: []
    };
  },
  async mounted() {
    try {
      let { data } = await axios.get("//bricksamortar.com.au/blog/wp-json/wp/v2/posts?per_page=9&_embed");
      this.posts = data;
      
      this.posts.map((blog, key) => {
          blog.id = key;
          return blog;
        });

      this.blogGroups = chunk(data, 3);
      
      this.blogGroups.map((blog, key) => {
        if (key == 0) {
            blog.active = 'active';
        } else {
            blog.active = '';
        }
          return blog;
        });
      
    } catch (e) {
      this.posts = [
        {
          id: 1,
          excerpt: {
            rendered: "<p>Could not load blog posts at this time</p>"
          }
        }
      ];
    }
  }
};
</script>
